<template>
  <custom-callout
    class-main="mt-3 mb-n1"
    :border-color="statusColor"
    :has-toggle="false"
  >
    <div class="row py-1 mr-md-0 align-items-center">
      <div class="col-12 col-md-2 text-center border-right py-2">
        <div class="font-weight-bold color-black">
          <div class="border-bottom pb-3 d-flex align-items-center d-md-none">
            <em class="fas fa-circle" :class="`color-${statusColor}`" />
            <span class="ml-2">{{ data.sampleStatusName | empty }}</span>
          </div>
          <span
            :class="
              `mb-1 font-light font-16 py-2 mt-2 w-70 mx-auto badge badge-pill badge-${statusColor} d-none d-md-block`
            "
          >
            {{ data.sampleStatusName | empty }}
          </span>
        </div>
      </div>
      <div class="col-12 col-md-7">
        <div class="row">
          <div class="col-12 col-md-2">
            <span class="data-title d-block">Semestre:</span>
            <span class="font-14 color-black">
              {{ semester }}
            </span>
          </div>
          <div class="col-12 col-md-3 mt-3 mt-md-0">
            <span class="data-title d-block">Nombre del Especialista:</span>
            <span class="font-14 color-black">
              {{ data.specialistName | empty }}
            </span>
          </div>
          <div class="col-12 col-md-3 mt-3 mt-md-0">
            <span class="data-title d-block">Disciplina del Especialista:</span>
            <span class="font-14 color-black">
              {{ data.disciplineName | empty }}
            </span>
          </div>
          <div class="col-12 col-md-3 mt-3 mt-md-0">
            <span class="data-title d-block">Nombre del Maestro:</span>
            <span class="font-14 color-black">
              {{ data.teacherName | empty }}
            </span>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-12 col-md-6 mt-3 mt-md-0">
            <span class="data-title d-block">Nombre de la corporación:</span>
            <span class="font-14 color-black">
              {{ data.companyName | empty }}
            </span>
          </div>
        </div>
      </div>
      <div
        class="col-12 col-md-3 mt-3 mt-md-0 d-flex justify-content-center align-items-center"
      >
        <ActionButton
          v-if="showCompleteQuestionnaire"
          @click="onCompleteQuestionnaireHandler(data)"
          class="mr-2 complete-question-btn"
          variant="outline-success"
          i="fas fa-arrow-circle-right"
        >
          Completar Cuestionario
        </ActionButton>
      </div>
    </div>
  </custom-callout>
</template>

<script>
import alertMixin from "@quisit/mipe-utils/mixins/alert.mixin";

import CustomCallout from "custom-callout";
import DropDown from "dropdown";
import ActionButton from "ActionButton";
import { MIPE_PUBLIC_PORTAL_URL } from "@/config";
import { CustomTab, CustomTabItem } from "custom-tabs";

import { semesters as SEMESTERS } from "@/utils/constants/questionnaire-sample/codeQuestionnaireSamplePeriodNumber";
import {
  sampleStatuses as SAMPLE_STATUSES,
  getSampleStatusColor
} from "@/utils/constants/questionnaire-sample/codeQuestionnaireSampleStatus";

export default {
  name: "ResultRow",
  components: {
    CustomCallout,
    DropDown,
    CustomTab,
    CustomTabItem,
    ActionButton
  },
  mixins: [alertMixin],
  props: {
    data: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  data() {
    return {};
  },
  computed: {
    statusColor() {
      return getSampleStatusColor(this.data.sampleStatusId);
    },
    semester() {
      return SEMESTERS.find(x => x.id === this.data.periodNumber)?.name;
    },
    showCompleteQuestionnaire() {
      return [SAMPLE_STATUSES.Pending, SAMPLE_STATUSES.InProcess].includes(
        this.data.sampleStatusId
      );
    }
  },
  methods: {
    onCompleteQuestionnaireHandler(data) {
      window.open(data.questionnaireURL);
    }
  }
};
</script>
<style scoped lang="scss">
@import "@/assets/scss/variables/_colors.scss";
.badge-yellow {
  background-color: map-get($colors, "yellow");
}
.badge-green-light {
  background-color: map-get($colors, "green-light");
}
.badge-orange {
  background-color: map-get($colors, "secondary-26");
}
.badge-brown {
  background-color: map-get($colors, "brown");
}
.badge-violet {
  background-color: map-get($colors, "violet");
}

::v-deep .border-left--color-orange {
  border-left-color: map-get($colors, "secondary-26") !important;
}

@media only screen and (max-width: 768px) {
  .complete-question-btn {
    width: 100%;
  }
}
</style>
